import { Button, Drawer, Space } from "antd";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import formatShort from "../../../utils/formatShort";
import getExpenseByCenter from "../../../utils/getExpenseByCenter";
import MonthlyPanel from "./MonthlyPanel";

export default function ComputerPanel({
  isVisible,
  setVisible,
  expenses,
  year,
  title,
}: any) {
  const [monthly, setMonthly] = useState<any>([]);
  const [details, setDetails] = useState<any>({});
  const [showMonthly, setShowMonthly] = useState<boolean>(false);
  const salesDept = getExpenseByCenter(expenses, [], 10, year);
  const partsDept = getExpenseByCenter(expenses, [], 30, year);
  const serv2Dept = getExpenseByCenter(expenses, [], 40, year);
  const serviceDept = getExpenseByCenter(expenses, [], 41, year);
  const clearingDept = getExpenseByCenter(expenses, [], 50, year);
  const adminDept = getExpenseByCenter(expenses, [], 80, year);
  const financeDept = getExpenseByCenter(expenses, [], 82, year);
  const marketingDept = getExpenseByCenter(expenses, [], 86, year);
  const itDept = getExpenseByCenter(expenses, [], 87, year);
  const hrDept = getExpenseByCenter(expenses, [], 88, year);
  const trainingDept = getExpenseByCenter(expenses, [], 89, year);
  const distributionDept = getExpenseByCenter(expenses, [], 90, year);
  const operationsDept = getExpenseByCenter(expenses, [], 91, year);

  const getMonthlyTotal = (month_code: any) => {
    let total =
      salesDept[month_code].expenses +
      partsDept[month_code].expenses +
      serv2Dept[month_code].expenses +
      serviceDept[month_code].expenses +
      clearingDept[month_code].expenses +
      adminDept[month_code].expenses +
      financeDept[month_code].expenses +
      marketingDept[month_code].expenses +
      itDept[month_code].expenses +
      hrDept[month_code].expenses +
      trainingDept[month_code].expenses +
      distributionDept[month_code].expenses +
      operationsDept[month_code].expenses;

    return total;
  };

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">
            <span className="font-bold mr-2">{title} :</span>
            <span>[ All Departments / Cost Centers ]</span>
          </span>
          {year}
        </div>
      }
      placement={"right"}
      width={1000}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center  mb-2 pb-2 -mt-4">
          <table className="w-full">
            <thead>
              <tr className="border-gray-500 border-b border-t bg-gray-100 py-2">
                <th className="bg-gray-300 p-2 border-b border-r border-gray-400 text-left">
                  Cost Center
                </th>
                <th className="p-2 bg-gray-300">Jan</th>
                <th className="p-2 bg-gray-300">Feb</th>
                <th className="p-2 bg-gray-300">Mar</th>
                <th className="p-2 bg-gray-300">Apr</th>
                <th className="p-2 bg-gray-300">May</th>
                <th className="p-2 bg-gray-300">Jun</th>
                <th className="p-2 bg-gray-300">Jul</th>
                <th className="p-2 bg-gray-300">Aug</th>
                <th className="p-2 bg-gray-300">Sep</th>
                <th className="p-2 bg-gray-300">Oct</th>
                <th className="p-2 bg-gray-300">Nov</th>
                <th className="p-2 bg-gray-300">Dec</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  10 - Sales
                </td>
                {salesDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Sales Department",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>
              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  30 - Parts
                </td>
                {partsDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Parts Department",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>
              <tr className="border-b">
                <td className="bg-gray-200 p-2 border-b border-gray-300">
                  40 - Service
                </td>
                {serv2Dept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Service Department - 40 ",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>
              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  41 - Service
                </td>
                {serviceDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Service Department - 41 ",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>
              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  50 - C&F
                </td>
                {clearingDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Clearing & Forwarding",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>
              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  80 - Admin
                </td>
                {adminDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Admin Department",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>
              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  82 - Finance
                </td>
                {financeDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Finance Department",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>

              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  86 - Marketing
                </td>
                {marketingDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Marketing Department",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>

              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  87 - IT
                </td>
                {itDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({ title: "IT Department", month: item?.name });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>

              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  88 - HR
                </td>
                {hrDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({ title: "HR Department", month: item?.name });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>

              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  89 - Training
                </td>
                {trainingDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Training Department",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>
              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  90 - Distribution
                </td>
                {distributionDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Distribution Department",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>

              <tr className="border-b">
                <td className="bg-gray-200  p-2 border-b border-gray-300">
                  91 - Operations
                </td>
                {operationsDept?.map((item: any) => (
                  <td
                    className="p-2 text-center hover:bg-green-100 hover:cursor-pointer"
                    onClick={() => {
                      setMonthly(item);
                      setDetails({
                        title: "Operations Department",
                        month: item?.name,
                      });
                      setShowMonthly(true);
                    }}
                  >
                    {item?.expenses === 0 ? "-" : formatShort(item?.expenses)}
                  </td>
                ))}
              </tr>

              <tr className="border-t-2 border-b border-gray-400 py-2">
                <th className="py-2">Total</th>
                <th className="p-2">{formatShort(getMonthlyTotal(0))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(1))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(2))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(3))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(4))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(5))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(6))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(7))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(8))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(9))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(10))}</th>
                <th className="p-2">{formatShort(getMonthlyTotal(11))}</th>
              </tr>
            </tbody>
          </table>
        </div>

        <MonthlyPanel
          isVisible={showMonthly}
          setVisible={setShowMonthly}
          selected={monthly}
          details={details}
        />
      </div>
    </Drawer>
  );
}
